var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-wrapper" },
            [
              _c("div", { staticClass: "container-wrapper center" }, [
                _c("div", [
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v("Courses")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-red btn-md input-height-15 float-right text-align-right",
                      on: {
                        click: function($event) {
                          ;(_vm.isAddCourseModalVisible = true),
                            _vm.verrors.clear(),
                            (_vm.image = "")
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus spacer-icon",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("External Course")
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "heading-seperator" }),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "div",
                  {},
                  [
                    _c(
                      "b-navbar",
                      {
                        attrs: {
                          toggleable: "lg",
                          type: "light",
                          variant: "light"
                        }
                      },
                      [
                        _c("b-navbar-brand", { attrs: { href: "#" } }, [
                          _vm._v("Filter/Search")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-navbar-toggle",
                          { attrs: { target: "nav-collapse" } },
                          [_c("i", { staticClass: "fa fa-chevron-down   " })]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          { attrs: { id: "nav-collapse", "is-nav": "" } },
                          [
                            _c(
                              "div",
                              { staticClass: "search-wrapper col-12" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row col-12 override-padding"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-4 col-md-12 col-12"
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "input-text",
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              "Search by Course Title",
                                            maxlength: "255"
                                          },
                                          on: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.filterCourseitems()
                                            }
                                          },
                                          model: {
                                            value: _vm.search_keyword,
                                            callback: function($$v) {
                                              _vm.search_keyword = $$v
                                            },
                                            expression: "search_keyword"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-3 col-md-12 col-12 padding-lr-5"
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "input-text",
                                          attrs: {
                                            options: _vm.status_options
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.filterCourseitems()
                                            }
                                          },
                                          model: {
                                            value: _vm.search_status,
                                            callback: function($$v) {
                                              _vm.search_status = $$v
                                            },
                                            expression: "search_status"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-lg-4 col-md-10 col-10"
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "input-text",
                                          attrs: {
                                            options:
                                              _vm.affiliate_options_search
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.filterCourseitems()
                                            }
                                          },
                                          model: {
                                            value: _vm.search_affiliate,
                                            callback: function($$v) {
                                              _vm.search_affiliate = $$v
                                            },
                                            expression: "search_affiliate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.filterCourseitems()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "search-icon" },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-search"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("div", { staticClass: "row tasks_heading_row" }, [
                          _c(
                            "div",
                            { staticClass: "bold cursor-pointer  col-2" },
                            [
                              _vm._v(
                                "\n                                Course Title                       \n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer  col-1 override-padding"
                            },
                            [
                              _vm._v(
                                "\n                                Course ID\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-1 override-padding"
                            },
                            [
                              _vm._v(
                                "\n                                # of Modules\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-2 override-padding"
                            },
                            [
                              _vm._v(
                                "\n                                 # of Final Exam Q's\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-1 override-padding"
                            },
                            [
                              _vm._v(
                                "\n                                Last Updated\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-2 override-padding"
                            },
                            [
                              _vm._v(
                                "\n                                Last Updated By \n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-1 override-padding"
                            },
                            [
                              _vm._v(
                                "\n                                # of Affiliates\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bold cursor-pointer col-1 override-padding"
                            },
                            [
                              _vm._v(
                                "\n                                Access\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "bold cursor-pointer col-1 override-padding"
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.loading,
                                expression: "loading"
                              }
                            ],
                            staticClass: "loading_show"
                          },
                          [
                            _c("div", {
                              staticClass: "spinner-border text-danger"
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.course_lists.length > 0
                          ? _c(
                              "b-card-text",
                              _vm._l(_vm.course_lists, function(
                                courseinfo,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { staticClass: "tasklist-row" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row tasklist-item",
                                        staticStyle: { margin: "0" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-2 package-name" },
                                          [
                                            _vm._v(
                                              _vm._s(courseinfo.course_name)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 override-padding"
                                          },
                                          [_vm._v(_vm._s(courseinfo.course_id))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 override-padding"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(courseinfo.module_count)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 override-padding"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(courseinfo.questions_count)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 override-padding"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(courseinfo.updated_time)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 override-padding"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(courseinfo.updated_by)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-1 override-padding"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                courseinfo.no_of_affiliates
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        courseinfo.course_id ==
                                        "External Course"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-1 override-padding cursor-pointer bold"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      id: "manage-link"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.getExternalCourseDetails(
                                                          courseinfo.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Edit")]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-1 override-padding cursor-pointer bold"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      id: "manage-link"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.manageCourse(
                                                          courseinfo.course_id,
                                                          courseinfo.course_name
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Manage")]
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        courseinfo.course_id ==
                                        "External Course"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-1 override-padding"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "dropdown",
                                                    attrs: {
                                                      id:
                                                        "dropdown-container" +
                                                        index
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleDropdown(
                                                          "actionDropdown" +
                                                            index +
                                                            ""
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "dropbtn icons btn-right showLeft",
                                                        attrs: {
                                                          id:
                                                            "dotted-menu" +
                                                            index
                                                        }
                                                      },
                                                      [
                                                        _c("li"),
                                                        _vm._v(" "),
                                                        _c("li"),
                                                        _vm._v(" "),
                                                        _c("li")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dropdown-content",
                                                        attrs: {
                                                          id:
                                                            "actionDropdown" +
                                                            index
                                                        }
                                                      },
                                                      [
                                                        courseinfo.status ==
                                                        "DRAFT"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "action-dd-menu",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateCourseStatus(
                                                                      courseinfo.id,
                                                                      "PUBLISH"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "cursor-pointer fa fa-upload spacer-icon"
                                                                }),
                                                                _vm._v(
                                                                  "Publish"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        courseinfo.status ==
                                                          "DRAFT" ||
                                                        courseinfo.status ==
                                                          "DEACTIVATED"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "action-dd-menu",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteCourseConfirm(
                                                                      courseinfo.id
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "cursor-pointer fa fa-times spacer-icon"
                                                                }),
                                                                _vm._v("Remove")
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        courseinfo.status ==
                                                        "PUBLISH"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "action-dd-menu",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.deactivateCourseConfirm(
                                                                      courseinfo.id,
                                                                      courseinfo.course_name
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "cursor-pointer fa fa-eye-slash spacer-icon"
                                                                }),
                                                                _vm._v(
                                                                  "Deactivate"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-1 override-padding"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "dropdown",
                                                    attrs: {
                                                      id:
                                                        "dropdown-container" +
                                                        index
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "dropbtn icons btn-right showLeft",
                                                        attrs: {
                                                          id:
                                                            "dotted-menu" +
                                                            index
                                                        }
                                                      },
                                                      [
                                                        _c("li"),
                                                        _vm._v(" "),
                                                        _c("li"),
                                                        _vm._v(" "),
                                                        _c("li")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass:
                                                        "dropdown-content",
                                                      attrs: {
                                                        id:
                                                          "actionDropdown" +
                                                          index
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [_c("hr")])
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm.loading == false
                          ? _c("b-card-text", [
                              _vm._v(
                                "\n                                No Courses found.\n                        "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "ManageCourseModal",
                {
                  attrs: { isModalVisible: _vm.isModalVisible },
                  on: {
                    close: function($event) {
                      _vm.isModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n    Loading...\n  ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("div", { staticClass: "sub-heading" }, [
                      _c("h3", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v("Course: " + _vm._s(_vm.courseTitle))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.isModalVisible == true
                    ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c(
                            "div",
                            {
                              staticClass: "search-padd",
                              attrs: { id: "mentee-group-wrapper" }
                            },
                            [
                              _c("multiselect", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  options: _vm.affiliate_options,
                                  "track-by": "text",
                                  label: "text",
                                  placeholder: "Select Affiliates...",
                                  multiple: true,
                                  "close-on-select": false,
                                  "show-labels": false,
                                  name: "affiliate[]",
                                  id: "affiliate"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var values = ref.values
                                      var search = ref.search
                                      var isOpen = ref.isOpen
                                      return [
                                        values.length && !isOpen
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__single"
                                              },
                                              [
                                                _vm._v(
                                                  "Affiliates (" +
                                                    _vm._s(values.length) +
                                                    " selected)"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.affiliate_selected,
                                  callback: function($$v) {
                                    _vm.affiliate_selected = $$v
                                  },
                                  expression: "affiliate_selected"
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("affiliate[]", "required")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Affilates is required")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c(
                            "div",
                            {
                              staticClass: "search-padd",
                              attrs: { id: "mentee-group-wrapper" }
                            },
                            [
                              _c("multiselect", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  options: _vm.roles_options,
                                  "track-by": "name",
                                  label: "name",
                                  placeholder: "Select Users...",
                                  multiple: true,
                                  "close-on-select": false,
                                  "show-labels": false,
                                  name: "roles",
                                  id: "roles"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var values = ref.values
                                      var search = ref.search
                                      var isOpen = ref.isOpen
                                      return [
                                        values.length && !isOpen
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multiselect__single"
                                              },
                                              [
                                                _vm._v(
                                                  "Users (" +
                                                    _vm._s(values.length) +
                                                    " selected)"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.roles_selected,
                                  callback: function($$v) {
                                    _vm.roles_selected = $$v
                                  },
                                  expression: "roles_selected"
                                }
                              }),
                              _vm._v(" "),
                              _vm.verrors.firstByRule("roles", "required")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "margin-bottom-5 validate-warning-msg"
                                    },
                                    [_vm._v("Users is required")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 override-padding text-align-right"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-dard-grey col-lg-3",
                                staticStyle: {
                                  "line-height": "30px",
                                  "border-radius": "10px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.saveCourseAffiliates()
                                  }
                                }
                              },
                              [_c("b", [_vm._v("Save")])]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "CreateCourseModal",
                {
                  attrs: { isModalVisible: _vm.isAddCourseModalVisible },
                  on: {
                    close: function($event) {
                      _vm.isAddCourseModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n      Loading...\n    ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      staticStyle: { color: "#00" },
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("h3", [_vm._v("Add External Course")])]
                  ),
                  _vm._v(" "),
                  _vm.isAddCourseModalVisible == true
                    ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.course_name,
                                expression: "course_name"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass:
                              "col-lg-12 input-height-25 input-class",
                            attrs: {
                              name: "course_name",
                              placeholder: "Enter External Course Name",
                              maxlength: "255"
                            },
                            domProps: { value: _vm.course_name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.course_name = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.verrors.firstByRule("course_name", "required")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "margin-bottom-5 validate-warning-msg"
                                },
                                [_vm._v("External Course Name is required")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.course_organization,
                                expression: "course_organization"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass:
                              "col-lg-12 input-height-25 input-class",
                            attrs: {
                              name: "course_organization",
                              placeholder: "Course Organization",
                              maxlength: "255"
                            },
                            domProps: { value: _vm.course_organization },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.course_organization = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.verrors.firstByRule(
                            "course_organization",
                            "required"
                          )
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "margin-bottom-5 validate-warning-msg"
                                },
                                [_vm._v("Course Organization is required")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-12 override-padding",
                            staticStyle: { display: "flex" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "search-padd",
                                staticStyle: { height: "30px", width: "100%" },
                                attrs: { id: "affliate-wrapper" }
                              },
                              [
                                _c("multiselect", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    options: _vm.affiliate_options,
                                    "track-by": "value",
                                    label: "text",
                                    placeholder: "Select Affiliate",
                                    multiple: true,
                                    "close-on-select": false,
                                    "show-labels": false,
                                    name: "extaffiliate[]",
                                    id: "extaffiliate"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "selection",
                                      fn: function(ref) {
                                        var values = ref.values
                                        var search = ref.search
                                        var isOpen = ref.isOpen
                                        return [
                                          values.length && !isOpen
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(values.length) +
                                                      " selected"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.affiliate,
                                    callback: function($$v) {
                                      _vm.affiliate = $$v
                                    },
                                    expression: "affiliate"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("extaffiliate[]", "required")
                          ? _c(
                              "div",
                              {
                                staticClass: "validate-warning-msg",
                                staticStyle: { "margin-top": "15px" }
                              },
                              [_vm._v("Affiliate is required")]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "validate-warning-msg",
                                staticStyle: { "margin-top": "-5px" }
                              },
                              [_vm._v(" ")]
                            ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.course_link,
                                expression: "course_link"
                              }
                            ],
                            staticClass:
                              "col-lg-12 input-height-25 input-class",
                            attrs: {
                              name: "course_link",
                              placeholder:
                                "External Course Link or Registration Link",
                              maxlength: "255"
                            },
                            domProps: { value: _vm.course_link },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.course_link = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.verrors.has("course_link")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "margin-bottom-5 validate-warning-msg"
                                },
                                [_vm._v("Link is invalid")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            ref: "image_file",
                            staticClass: "input-file",
                            attrs: {
                              type: "file",
                              name: "image_file",
                              accept: "image/*",
                              rules: "required"
                            },
                            on: { change: _vm.handleImage }
                          }),
                          _vm._v(" "),
                          _vm.verrors.firstByRule("image_file", "required")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "margin-bottom-5 validate-warning-msg"
                                },
                                [_vm._v("Logo is required")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "help-text" }, [
                            _vm._v(
                              "Logo should be jpg, jpeg, gif, png and size should be of 2MB"
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            staticStyle: { clear: "both" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _vm.image
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-9 float-left p-0 text-center",
                                  staticStyle: {
                                    border: "1px solid #707070",
                                    height: "100px",
                                    width: "250px"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: { "padding-top": "10px" },
                                    attrs: {
                                      src: _vm.image,
                                      width: "100",
                                      height: "85"
                                    }
                                  })
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left p-0",
                                  staticStyle: {
                                    border: "1px solid #707070",
                                    height: "100px",
                                    width: "250px",
                                    "text-align": "center",
                                    "padding-top": "35px !important"
                                  }
                                },
                                [_vm._v("\n          Logo Example\n        ")]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-3 text-align-right float-right p-0",
                              staticStyle: {
                                "margin-right": "0px",
                                "margin-top": "60px"
                              }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-red col-lg-12 input-height-25 createBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.createCourse()
                                    }
                                  }
                                },
                                [_c("b", [_vm._v("Create")])]
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "EditCourseModal",
                {
                  attrs: { isModalVisible: _vm.isEditModalVisible },
                  on: {
                    close: function($event) {
                      _vm.isEditModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n      Loading...\n    ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("h3", [_vm._v("Edit External Course")])]
                  ),
                  _vm._v(" "),
                  _vm.isEditModalVisible == true
                    ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.edit_course_name,
                                expression: "edit_course_name"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass:
                              "col-lg-12 input-height-25 input-class",
                            attrs: {
                              name: "edit_course_name",
                              placeholder: "Enter External Course Name",
                              maxlength: "255"
                            },
                            domProps: { value: _vm.edit_course_name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.edit_course_name = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.verrors.firstByRule(
                            "edit_course_name",
                            "required"
                          )
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "margin-bottom-5 validate-warning-msg"
                                },
                                [_vm._v("External Course Name is required")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.edit_course_organization,
                                expression: "edit_course_organization"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass:
                              "col-lg-12 input-height-25 input-class",
                            attrs: {
                              name: "edit_course_organization",
                              placeholder: "Course Organization",
                              maxlength: "255"
                            },
                            domProps: { value: _vm.edit_course_organization },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.edit_course_organization =
                                  $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.verrors.firstByRule(
                            "edit_course_organization",
                            "required"
                          )
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "margin-bottom-5 validate-warning-msg"
                                },
                                [_vm._v("Course Organization is required")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-12 override-padding",
                            staticStyle: { display: "flex" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "search-padd",
                                staticStyle: { height: "30px", width: "100%" },
                                attrs: { id: "affliate-wrapper" }
                              },
                              [
                                _c("multiselect", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    options: _vm.affiliate_options,
                                    "track-by": "value",
                                    label: "text",
                                    placeholder: "Select Affiliate",
                                    multiple: true,
                                    "close-on-select": false,
                                    "show-labels": false,
                                    name: "edit_affiliate[]",
                                    id: "affiliate"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "selection",
                                      fn: function(ref) {
                                        var values = ref.values
                                        var search = ref.search
                                        var isOpen = ref.isOpen
                                        return [
                                          values.length && !isOpen
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(values.length) +
                                                      " selected"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.edit_affiliate,
                                    callback: function($$v) {
                                      _vm.edit_affiliate = $$v
                                    },
                                    expression: "edit_affiliate"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("edit_affiliate[]", "required")
                          ? _c(
                              "div",
                              {
                                staticClass: "validate-warning-msg",
                                staticStyle: { "margin-top": "15px" }
                              },
                              [_vm._v("Affiliate is required")]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "validate-warning-msg",
                                staticStyle: { "margin-top": "-5px" }
                              },
                              [_vm._v(" ")]
                            ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.edit_course_link,
                                expression: "edit_course_link"
                              }
                            ],
                            staticClass:
                              "col-lg-12 input-height-25 input-class",
                            attrs: {
                              name: "edit_course_link",
                              placeholder: "Course Link or Registration Link",
                              maxlength: "255"
                            },
                            domProps: { value: _vm.edit_course_link },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.edit_course_link = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.verrors.firstByRule("edit_course_link")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "margin-bottom-5 validate-warning-msg"
                                },
                                [_vm._v("Link is invalid")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _vm.edit_image_flag == 1
                          ? _c(
                              "div",
                              { staticClass: "col-12 override-padding" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  ref: "edit_image_file",
                                  staticClass: "input-file",
                                  attrs: {
                                    type: "file",
                                    name: "edit_image_file",
                                    accept: "image/*",
                                    rules: "required"
                                  },
                                  on: { change: _vm.handleEditImage }
                                }),
                                _vm._v(" "),
                                _vm.verrors.firstByRule(
                                  "edit_image_file",
                                  "required"
                                )
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "margin-bottom-5 validate-warning-msg"
                                      },
                                      [_vm._v("Logo is required")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "help-text" }, [
                                  _vm._v(
                                    "Logo should be jpg, jpeg, gif, png and size should be of 2MB"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "margin-bottom-10",
                                  staticStyle: { clear: "both" }
                                })
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "col-12 override-padding" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-red btn-md input-height-15 col-4",
                                    staticStyle: { height: "30px" },
                                    on: {
                                      click: function($event) {
                                        return _vm.RemoveImage()
                                      }
                                    }
                                  },
                                  [_c("b", [_vm._v("Remove Image")])]
                                )
                              ]
                            ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 override-padding" }, [
                          _vm.edit_image
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-9 float-left p-0 text-center",
                                  staticStyle: {
                                    border: "1px solid #707070",
                                    height: "100px",
                                    width: "250px"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: { "padding-top": "10px" },
                                    attrs: {
                                      src: _vm.edit_image,
                                      width: "100",
                                      height: "85"
                                    }
                                  })
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left p-0",
                                  staticStyle: {
                                    border: "1px solid #707070",
                                    height: "100px",
                                    width: "250px",
                                    "text-align": "center",
                                    "padding-top": "35px !important"
                                  }
                                },
                                [_vm._v("\n          Logo Example\n        ")]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-3 text-align-right float-right p-0",
                              staticStyle: {
                                "margin-right": "0px",
                                "margin-top": "60px"
                              }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-red col-lg-12 input-height-25 createBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.editCourse()
                                    }
                                  }
                                },
                                [_c("b", [_vm._v("Save")])]
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "DeleteModal",
                {
                  attrs: {
                    isModalVisible: _vm.isDeleteModalVisible,
                    id: _vm.id
                  },
                  on: {
                    close: function($event) {
                      _vm.isDeleteModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n      Loading...\n    ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_vm._v("Are you sure you want to delete the course?")]
                  ),
                  _vm._v(" "),
                  _c("div", { attrs: { slot: "body" }, slot: "body" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "left col-12 btn btn-red",
                          on: {
                            click: function($event) {
                              _vm.showingdeleteModal = false
                              _vm.deleteCourse(_vm.id)
                            }
                          }
                        },
                        [_vm._v("Confirm")]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "DeactivateModal",
                {
                  attrs: {
                    isModalVisible: _vm.isDeactivateModalVisible,
                    id: _vm.deactivateId
                  },
                  on: {
                    close: function($event) {
                      _vm.isDeactivateModalVisible = false
                    }
                  }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n      Loading...\n    ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_vm._v("Are you sure you want to deactivate the course? ")]
                  ),
                  _vm._v(" "),
                  _c("div", { attrs: { slot: "body" }, slot: "body" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-3 override-padding",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "left col-12 btn btn-red",
                          on: {
                            click: function($event) {
                              _vm.showingdeleteModal = false
                              _vm.deactivateCourse(_vm.deactivateId)
                            }
                          }
                        },
                        [_vm._v("Confirm")]
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45b772a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45b772a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/course_list.vue
// module id = null
// module chunks = 